import SecaoEtiquetas from '@/components/configuracoes/SecaoEtiquetas';
import SecaoRespostasRapidas from '@/components/configuracoes/SecaoRespostasRapidas';

/**
 * Preferências do setor — etiquetas e respostas rápidas de quem atende ali.
 *
 * Saíram de Configurações (23/ago). O motivo é operacional, não de organização:
 * quem descobre que falta uma etiqueta ou uma resposta pronta é quem está
 * atendendo, e ter de pedir ao gestor fazia a ferramenta não ser usada. As
 * `firestore.rules` autorizam cada papel apenas no seu espaço.
 *
 * NÃO depende do `ConversasProvider`: esta página vive fora do inbox, e o
 * `clinicaId` vem do `useAuth` — o mesmo caminho das seções de Configurações.
 */

const SETOR = {
  recepcao: 'Recepção',
  vendas: 'Vendas / SDR',
};

export default function PreferenciasPage({ espaco }) {
  return (
    <div className="pagina">
      <header className="pagina-cabecalho">
        <h1>Preferências</h1>
        <p className="painel-sub">
          Etiquetas e respostas rápidas — <strong>{SETOR[espaco] ?? espaco}</strong>. A equipe
          do setor ajusta.
        </p>
      </header>

      {/* Respostas antes de etiquetas: a resposta rápida é usada em toda
          conversa; a etiqueta, de vez em quando. */}
      <SecaoRespostasRapidas espaco={espaco} />

      <SecaoEtiquetas espaco={espaco} />
    </div>
  );
}
